function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import css from './Grid.sass';

function Col(props) {
  var children = props.children,
      size = props.size,
      push = props.push,
      pull = props.pull,
      lPull = props.lPull,
      lPush = props.lPush,
      mPull = props.mPull,
      mPush = props.mPush,
      sPull = props.sPull,
      sPush = props.sPush,
      lSize = props.lSize,
      mSize = props.mSize,
      sSize = props.sSize,
      lHide = props.lHide,
      xlHide = props.xlHide,
      mHide = props.mHide,
      sHide = props.sHide,
      xlShow = props.xlShow,
      lShow = props.lShow,
      mShow = props.mShow,
      sShow = props.sShow,
      align = props.align,
      vAlign = props.vAlign,
      order = props.order,
      textAlign = props.textAlign,
      className = props.className,
      restProps = _objectWithoutProperties(props, ["children", "size", "push", "pull", "lPull", "lPush", "mPull", "mPush", "sPull", "sPush", "lSize", "mSize", "sSize", "lHide", "xlHide", "mHide", "sHide", "xlShow", "lShow", "mShow", "sShow", "align", "vAlign", "order", "textAlign", "className"]);

  var classNames = cx(css.col, className, align && css["align-".concat(align)], vAlign && css["v-align-".concat(vAlign)], size && css["col-".concat(size)], lSize && css["col-l-".concat(lSize)], mSize && css["col-m-".concat(mSize)], sSize && css["col-s-".concat(sSize)], pull && css["pull-".concat(pull)], push && css["push-".concat(push)], lPull && css["pull-l-".concat(lPull)], lPush && css["push-l-".concat(lPush)], mPull && css["pull-m-".concat(mPull)], mPush && css["push-m-".concat(mPush)], sPull && css["pull-s-".concat(sPull)], sPush && css["push-s-".concat(sPush)], xlHide && css['xl-hide'], lHide && css['l-hide'], mHide && css['m-hide'], sHide && css['s-hide'], xlShow && css['xl-show'], lShow && css['l-show'], mShow && css['m-show'], sShow && css['s-show'], order && css["order-".concat(order)], textAlign && css["text-align-".concat(textAlign)]);
  return React.createElement("div", _extends({
    className: classNames
  }, restProps), children);
}

Col.displayName = 'Grid.Col';
Col.propTypes = {
  /**
   * Primary content
   */
  children: PropTypes.node,

  /**
   * size for all screens: 'n-of-p' | 'auto' */
  size: PropTypes.string,

  /**
   * size for large screens: 'n-of-p' | 'auto' */
  lSize: PropTypes.string,

  /**
   * size for medium screens: 'n-of-p' | 'auto' */
  mSize: PropTypes.string,

  /**
   * size for small and extra small screens: 'n-of-p' | 'auto' */
  sSize: PropTypes.string,

  /**
   * hide on extra large screens  */
  xlHide: PropTypes.bool,

  /**
   * hide on large screens  */
  lHide: PropTypes.bool,

  /**
   * hide on medium screens  */
  mHide: PropTypes.bool,

  /**
   * hide on small and exta small screens  */
  sHide: PropTypes.bool,

  /**
   * show on extra large screens  */
  xlShow: PropTypes.bool,

  /**
   * show on large screens  */
  lShow: PropTypes.bool,

  /**
   * show on medium screens  */
  mShow: PropTypes.bool,

  /**
   * show on small and exta small screens  */
  sShow: PropTypes.bool,

  /**
   * push column right: 'n-of-p' | '0' */
  push: PropTypes.string,

  /**
   * pull column left: 'n-of-p' | '0' */
  pull: PropTypes.string,

  /**
   * pull column left large screen */
  lPull: PropTypes.string,

  /**
   * push column left on large screen */
  lPush: PropTypes.string,

  /**
   * pull column left on medium screen */
  mPull: PropTypes.string,

  /**
   * push column left on medium screen */
  mPush: PropTypes.string,

  /**
   * pull column left on small & extra small screen */
  sPull: PropTypes.string,

  /**
   * push column left on small & extra small screen */
  sPush: PropTypes.string,

  /**
   * horizontal align  */
  align: PropTypes.string,

  /**
   * vertical align  */
  vAlign: PropTypes.string,

  /**
   * flex order in row  */
  order: PropTypes.string,

  /**
   * Text align
   * */
  textAlign: PropTypes.string,
  className: PropTypes.string
};
Col.defaultProps = {
  size: 'auto'
};
export { Col };